import { motion } from "framer-motion";
import { scrollToId } from "../landing/shared";

const links = [
  { label: "WATCH", id: "watch" },
  { label: "THE METHOD", id: "method" },
  { label: "HOST", id: "host" },
  { label: "FAQ", id: "faq" },
];

export default function ReplayNav() {
  return (
    <motion.nav
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-1 rounded-full border border-white/10 bg-[#001736]/60 backdrop-blur-xl px-2 py-1.5"
      data-testid="replay-floating-nav"
    >
      {links.map((l) => (
        <button
          key={l.id}
          data-testid={`replay-nav-link-${l.id}`}
          onClick={() => scrollToId(l.id)}
          className="font-mono-strict text-[11px] tracking-[0.18em] text-white/60 hover:text-white px-2.5 sm:px-4 py-2 transition-colors duration-200 whitespace-nowrap"
        >
          {l.label}
        </button>
      ))}
      <button
        data-testid="replay-nav-apply-cta"
        data-cursor="cta"
        onClick={() => scrollToId("apply")}
        className="font-mono-strict text-[11px] tracking-[0.18em] font-bold bg-[#0162CA] text-white rounded-full px-4 sm:px-5 py-2 hover:bg-[#0a71dd] transition-colors duration-200 whitespace-nowrap"
      >
        START MY APPLICATION ↗
      </button>
    </motion.nav>
  );
}
